import { render, staticRenderFns } from "./commentScore.vue?vue&type=template&id=3eef4f8c&scoped=true&"
import script from "./commentScore.vue?vue&type=script&lang=js&"
export * from "./commentScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eef4f8c",
  null
  
)

export default component.exports